<template>
  <div class="nav" :class="{ open }">
    <div class="nav__title" @click="open = !open">
      <slot name="title"/>
    </div>
    <div class="nav__list">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  data: () =>({
    open: false,
  }),
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.nav {
  padding: 20px 0;
  border-width: 1px 0;

  @include mobile {
    margin: 0 -20px;
    border: 1px solid #f5f5f5;
  }

  &:not(.open) {
    @include mobile {
      .nav__title {
        text-decoration: underline;
        color: #484848;
      }

      .nav__list {
        display: none;
      }
    }
  }

  &__title {
    font-size: 20px;
    font-weight: 700;
    color: #83ca54;
    transition: all 0.3s;

    @include desktop {
      color: #484848;
      font-size: 14px;
      font-weight: 700;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    @include mobile {
      align-items: center;
    }

    & > * {
      color: #919191;
      font-size: 14px;
      margin-top: 20px;
      text-decoration: none;

      &:after {
        content: '';
        height: 1px;
        background: #83ca54;
        display: block;
        transform: scaleX(0);
        transition: all 0.3s;
        transform-origin: left;
      }

      &:hover:after {
        transform: scaleX(1);
      }
    }
  }
}
</style>